import { AppConfigModel } from "../abstract/app-config.model";

export class PricingMode extends AppConfigModel {

    static override CLASS_NAME: string = 'PricingMode';
}
